import { render, staticRenderFns } from "./CreateNewInsuranceStatusModal.vue?vue&type=template&id=3dc0b00d"
import script from "./CreateNewInsuranceStatusModal.vue?vue&type=script&lang=js"
export * from "./CreateNewInsuranceStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports